import { useConfiguracoes } from 'hooks/configuracoes'
import { parseVersionFollowingSemVer } from 'util/string/string-parseVersion'

import { NewsBalancedTopicsSection } from '../components/NewsBalancedTopicsSection'
import useNewsItems from '../hooks/useNewsItems'

export function NewsModalBodyLinks() {
  const newsItems = useNewsItems()

  const {
    configuracoes: { versao },
  } = useConfiguracoes()

  const { major, minor } = parseVersionFollowingSemVer(versao)
  const currentVersionFormattedKey = `${major}-${minor}`

  const mostRecentTopics = newsItems[currentVersionFormattedKey].topics

  return <NewsBalancedTopicsSection topics={mostRecentTopics} />
}
